import React from "react";
import { Monitor, Tablet } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

export function DeviceCheck({ children }: { children: React.ReactNode }) {
  const { t, dir } = useTranslation();

  return (
    <>
      {/* Smartphone message - shown only on small screens */}
      <div 
        className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-6 bg-background p-8 text-center sm:hidden"
        dir={dir}
      >
        <div className="flex items-center gap-4 text-primary">
          <Tablet className="w-16 h-16 rotate-90" />
          <Monitor className="w-20 h-20" />
        </div>
        <h1 className="text-2xl font-bold text-foreground">
          {t("deviceNotSupported")}
        </h1>
        <p className="text-lg text-muted-foreground max-w-md">
          {t("deviceNotSupportedDesc")}
        </p>
        <div className="mt-4 p-4 rounded-xl bg-primary/10 border border-primary/20">
          <p className="text-sm text-muted-foreground">
            {t("minScreenSize")}
          </p>
        </div>
      </div>

      {/* Main content - hidden on smartphones */}
      <div className="hidden sm:contents">
        {children}
      </div>
    </>
  );
}
